import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api";

export default function DoctorForgotPassword() {
  const [email,   setEmail]   = useState("");
  const [error,   setError]   = useState("");
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError("Enter your email"); return; }
    if (!/\S+@\S+\.\S+/.test(email)) { setError("Enter a valid email address"); return; }
    try {
      setLoading(true);
      setError("");
      await api.post("/doctor/forgot-password", { email: email.trim() });
      setSent(true);
    } catch {
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-100 p-4">
      <div className="w-full max-w-sm mb-4">
        <Link to="/staff-portal/login" className="inline-flex items-center gap-1.5 text-sm text-green-700 hover:text-green-900 transition">
          ← Back to Doctor Login
        </Link>
      </div>

      <form onSubmit={submit} className="card w-full max-w-sm space-y-4">
        <div className="text-center">
          <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-3 text-white text-xl">
            🔒
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Forgot Password</h1>
          <p className="text-sm text-gray-400 mt-1">
            {sent ? "Check your inbox for the reset link" : "We'll email you a link to reset it"}
          </p>
        </div>

        {sent ? (
          <div className="bg-green-50 border border-green-200 text-green-700 rounded-xl px-4 py-3 text-sm text-center">
            If an account exists with that email, a password reset link has been sent. The link expires in 1 hour.
          </div>
        ) : (
          <>
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 rounded-xl px-4 py-2 text-sm">
                {error}
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                className="input"
                type="email"
                placeholder="doctor@clinic.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                autoFocus
              />
            </div>

            <button type="submit" disabled={loading} className="btn-primary w-full">
              {loading ? "Sending…" : "Send Reset Link"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
